<rt-dialog-header>
  <div layout-full-width>
    <div layout layout-space-between>
      <rt-heading variant="heading large-x-dialog-header">
        {{ translationKey.dialog_2fa_sms.step_1.header | translate }}
      </rt-heading>
      <span layout layout-align-items-center margin-left-auto>
        {{ translationKey.dialog_2fa_sms.step_1.header_step | translate }}
      </span>
    </div>
    <span>{{ translationKey.dialog_2fa_sms.step_1.header_description | translate }}</span>
  </div>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <div layout-vertical>
    <rt-label [hasRequiredBadge]="true">{{
      translationKey.dialog_2fa_sms.step_1.phone | translate
    }}</rt-label>
    <rt-form-field margin-top-small-x>
      <rt-phone-input
        [formControl]="phoneControl"
        [placeholder]="translationKey.dialog_2fa_sms.step_1.phone_placeholder | translate"
        [countryCode]="countryCode"
      />
      @if (phoneControl.invalid && phoneControl.touched) {
        <div class="error-message" margin-top-small-x>
          @if (phoneControl.errors?.invalidNumber) {
            <span>{{ phoneErrors.invalidNumber }}</span>
          }
          @if (phoneControl.errors?.maxlength) {
            <span>{{ phoneErrors.maxlength }}</span>
          }
          @if (phoneControl.errors?.required) {
            <span>{{ phoneErrors.required }}</span>
          }
        </div>
      }
      @if (phoneApiError) {
        <div class="error-message" margin-top-small-x>
          {{ translationKey.dialog_2fa_sms.step_1.number_is_invalid | translate }}
        </div>
      }
    </rt-form-field>
    <span margin-top-small>{{
      translationKey.dialog_2fa_sms.step_1.phone_description | translate
    }}</span>
    <rt-infobox
      [iconName]="'info-outline'"
      [heading]="translationKey.dialog_2fa_sms.step_1.infobox_title | translate"
      [isDismissible]="false"
      margin-top-small-x
    >
      <div
        [innerHTML]="
          translationKey.dialog_2fa_sms.step_1.infobox_description
            | translate: { link: translationKey.dialog_2fa_sms.step_1.security_link | translate }
        "
      ></div>
    </rt-infobox>
  </div>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button (click)="onCancelClick()" variant="plain">{{
    translationKey.common.cancel | translate
  }}</rt-button>
  <rt-button
    [disabled]="phoneControl.invalid"
    (click)="onContinueClick()"
    [loading]="isLoading"
    variant="primary"
    >{{ translationKey.common.continue | translate }}
  </rt-button>
</rt-dialog-footer>
